import React from "react";
import { IdentityCheck } from "./IdentityCheck";

export const RunwayView = ({ runwayResult, runwayFrame, setRunwayFrame, sourcePhotoUrl }) => (
  <div>
    <div className="relative bg-white border border-black/10 aspect-[3/4] overflow-hidden polaroid">
      <img
        data-testid="runway-active-frame"
        src={runwayResult.frames[runwayFrame].result_data_url}
        alt="runway"
        className="w-full h-full object-cover"
      />
      <span className="absolute top-4 left-4 bg-black text-[#F6F5F1] px-3 py-1 font-mono-eyebrow">
        Frame {String(runwayFrame + 1).padStart(2, "0")} / {String(runwayResult.frames.length).padStart(2, "0")}
        {" · "}
        {runwayResult.frames[runwayFrame].background.replace("-", " ")}
      </span>
    </div>
    <div className={runwayResult.frames.length === 2 ? "grid grid-cols-2 gap-2 mt-3" : "grid grid-cols-3 gap-2 mt-3"}>
      {runwayResult.frames.map((f, i) => (
        <button
          key={f.tryon_id}
          data-testid={`runway-thumb-${i}`}
          onClick={() => setRunwayFrame(i)}
          className={`aspect-[3/4] overflow-hidden relative ${runwayFrame === i ? "ring-2 ring-[color:var(--accent)]" : "ring-1 ring-black/10 hover:ring-black"}`}
        >
          <img src={f.result_data_url} alt="" className="w-full h-full object-cover"/>
          <span className="absolute bottom-1 left-1 right-1 text-[9px] tracking-widest uppercase text-white bg-black/70 py-0.5 text-center">
            {f.background.replace("-", " ")}
          </span>
        </button>
      ))}
    </div>
    {sourcePhotoUrl && (
      <IdentityCheck
        beforeUrl={sourcePhotoUrl}
        afterUrl={runwayResult.frames[runwayFrame].result_data_url}
      />
    )}
  </div>
);
